import { IdentityDto } from './../shared/identity.dto';
import { EntityDto } from './../entity/entity.dto';

export class CampaignDto {
  clientId: string;
  identity: IdentityDto;
  entity: EntityDto;
  type: string;
  code: string;
  startDate: Date;
  endDate: Date;
  status: string;
  biller: string;
  budget: number;
  spend: number;
  precedence: number;

  errors?: any[];

  constructor(d?: CampaignDto) {
    if (!d) {
      return;
    }

    this.clientId = d.clientId;
    this.identity = d.identity;
    this.entity = d.entity;
    this.type = d.type;
    this.code = d.code;
    this.startDate = d.startDate;
    this.endDate = d.endDate;
    this.status = d.status;
    this.biller = d.biller;
    this.budget = d.budget;
    this.spend = d.spend;
    this.precedence = d.precedence;

    if (d.errors) {
      this.errors = d.errors;
    }
  }
}
